import { action } from 'satcheljs';
import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';

/**
 * Action to initialize the calendar processing options in store
 */
let initializeCalendarProcessingOptions = action(
    'initializeCalendarProcessingOptions',
    (calendarProcessingOptions: CalendarProcessingOptions) => ({
        calendarProcessingOptions,
    })
);

export default initializeCalendarProcessingOptions;
